module.exports = __webpack_public_path__ + "static/media/study220817.2b183607.png";